const SECTION_ID_PREFIX = 'shopify-section-';

const sectionCache = new Map<string, string>();
const pendingFetches = new Map<string, Promise<string>>();

export function normalizeSectionId(sectionId: string): string {
  return sectionId.replace(new RegExp(`^${SECTION_ID_PREFIX}`), '');
}

export function buildSectionRenderingUrl(sectionId: string, url: URL = new URL(window.location.href)): string {
  const requestUrl = new URL(url);
  requestUrl.searchParams.set('section_id', normalizeSectionId(sectionId));
  requestUrl.searchParams.sort();
  return requestUrl.toString();
}

export function clearSectionCache(): void {
  sectionCache.clear();
}

export async function getSectionHTML(
  sectionId: string,
  url: URL = new URL(window.location.href),
  useCache = true,
): Promise<string> {
  const sectionUrl = buildSectionRenderingUrl(sectionId, url);

  const pendingFetch = pendingFetches.get(sectionUrl);
  if (pendingFetch) {
    return pendingFetch;
  }

  if (useCache) {
    const cachedHtml = sectionCache.get(sectionUrl);
    if (cachedHtml) {
      return cachedHtml;
    }
  }

  const fetchPromise = fetch(sectionUrl).then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to render section (${response.status})`);
    }

    return response.text();
  });

  pendingFetches.set(sectionUrl, fetchPromise);

  try {
    const sectionHtml = await fetchPromise;
    sectionCache.set(sectionUrl, sectionHtml);
    return sectionHtml;
  } finally {
    pendingFetches.delete(sectionUrl);
  }
}
